import React from "react";

// Flat rounded-square file-type badge — the single visual implementation for
// every document/file type indicator in the app. Matches the Record View
// reference: compact rounded-square, centered bold white text, per-type color.
const TYPE_COLORS = {
  // Images — blue family
  png: "bg-blue-600",
  jpg: "bg-blue-500",
  jpeg: "bg-blue-500",
  gif: "bg-blue-400",
  webp: "bg-blue-500",
  tif: "bg-blue-400",
  tiff: "bg-blue-400",
  heic: "bg-blue-400",
  heif: "bg-blue-400",
  jfif: "bg-blue-400",
  ico: "bg-blue-300",

  // PDF — red
  pdf: "bg-red-500",

  // Word documents — indigo ("document blue")
  doc: "bg-indigo-600",
  docx: "bg-indigo-600",
  rtf: "bg-indigo-500",
  pages: "bg-indigo-500",

  // Spreadsheets — green
  xls: "bg-green-600",
  xlsx: "bg-green-600",
  csv: "bg-green-500",

  // Presentations — orange
  ppt: "bg-orange-600",
  pptx: "bg-orange-600",

  // Plain text — neutral
  txt: "bg-slate-500",
  bin: "bg-slate-400",

  // Archives — amber
  zip: "bg-amber-600",
  rar: "bg-amber-600",

  // Audio/video — purple
  mp3: "bg-purple-500",
  mp4: "bg-purple-600",
  mov: "bg-purple-600",
  wav: "bg-purple-500",
  m4a: "bg-purple-500",
  wma: "bg-purple-500",
  aac: "bg-purple-500",
  opus: "bg-purple-500",
  flac: "bg-purple-600",
  alac: "bg-purple-600",
  ogg: "bg-purple-600",
  midi: "bg-purple-500",
  aiff: "bg-purple-500",
  amr: "bg-purple-500",
  "3gp": "bg-purple-600",
  mp1: "bg-purple-500",
  mp2: "bg-purple-500",
  mpa: "bg-purple-500",
  mpeg: "bg-purple-600",
  mpg: "bg-purple-600",
  wmv: "bg-purple-600",

  // Mail/markup — teal/cyan
  eml: "bg-cyan-600",
  msg: "bg-cyan-600",
  html: "bg-teal-600",
  htm: "bg-teal-600",
  mhtml: "bg-teal-600",
  url: "bg-teal-500",
  ics: "bg-teal-500",
  one: "bg-teal-500",
  vcf: "bg-teal-500",
};

const DEFAULT_COLOR = "bg-gray-400";

export const getDocumentTypeColor = (type) =>
  TYPE_COLORS[String(type || "").toLowerCase()] || DEFAULT_COLOR;

const DocumentTypeBadge = ({ type, className = "" }) => {
  const label = String(type || "").toUpperCase();
  const colorClass = getDocumentTypeColor(type);
  const fontSizeClass = label.length > 4 ? "text-[6px]" : "text-[8px]";

  return (
    <div
      className={`flex h-[2em] w-[2em] shrink-0 items-center justify-center rounded-lg shadow-sm ${colorClass} ${className}`}
      aria-label={`${label} file`}
      title={label}
    >
      <span className={`${fontSizeClass} font-bold text-white leading-none`}>
        {label}
      </span>
    </div>
  );
};

export default DocumentTypeBadge;
